import React from 'react';

const Dashichoimbol = () => {
    return (
        <h1>Дашчоймбол дацан</h1>
        // <h1>Онгон</h1>
    )
}
export default Dashichoimbol;